module.exports = __webpack_public_path__ + "static/img/blog 768x1024.fd6132a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/capacitador/blog/blog 768x1024.jpg
// module id = fkze
// module chunks = 47